import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest, errorFormatHandler } from "../../helpers/apiHelper";

import { fetchUser } from "./user.api";

export const fetchUserToken = createAsyncThunk(
  "/login",
  async (
    params: {
      userName: string;
      password: string;
    },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const { data } = await apiRequest("/login", "POST", params);
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("token", data.token);

      dispatch(fetchUser());
      return data;
    } catch (err: any) {
      const error = errorFormatHandler(err);
      const status = err.response?.status;
      const serverMessage = err.response?.data?.message;

      if (
        status === 401 &&
        (!serverMessage ||
          serverMessage === "Unauthorized" ||
          serverMessage === "Unauthenticated.")
      ) {
        error.message = "Utilizator sau parolă incorectă.";
      } else if (!err.response) {
        error.message =
          "Nu s-a putut realiza conexiunea cu serverul. Verifică conexiunea și încearcă din nou.";
      } else if (status >= 500) {
        error.message =
          "Autentificarea nu este disponibilă momentan. Încearcă din nou mai târziu.";
      }

      return rejectWithValue(error);
    }
  },
);
